const Footer = () => (
  <footer className="flex justify-around items-center p-12 bg-black text-white mt-4">
    <h3 className="font-kanit">TRIBBLES</h3>
    <p className="font-kanit">© 2024 Hindley Milner Systems and DCF</p>
    <p className="font-kanit">Design support by roobinium.io</p>
  </footer>
);

export default Footer;
